module.exports = __webpack_public_path__ + "static/foton-d68040a9ca5e876a4a9b97127e30f98a.png";